import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const IconLivestream = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width={28}
      height={28}
      fill="none"
      viewBox="0 0 28 28"
      preserveAspectRatio="xMidYMid meet"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <rect x="5" y="4" width="18" height="16" rx="1" stroke="currentColor" fill="none" strokeWidth="2" />
      <rect x="8" y="23" width="12" height="2" rx="1" fill="currentColor" />
      <path
        d="M17.5 12C17.5 13.933 15.933 15.5 14 15.5C12.067 15.5 10.5 13.933 10.5 12C10.5 10.067 12.067 8.5 14 8.5C15.933 8.5 17.5 10.067 17.5 12Z"
        stroke="currentColor"
        fill="none"
      />
    </SvgIcon>
  );
};
